export default "__VITE_ASSET__B6rgCZQd__"